import { getAttribute } from "@api/attributes";
import { getVariant } from "@api/completion";
import { API_URL } from "@api/constants";
import { certificateImage, certificateVariant } from "@api/course";
import CourseCompletion from "@api/types/course-completion";
import React, { FC, useRef } from "react";

import Button from "@components/Button";

const CourseCertificateDownload: FC<{ completion: CourseCompletion }> = ({ completion }) => {
  const variant = getVariant(completion);
  const image = certificateImage(completion.courseObject, variant);
  const certVariant = certificateVariant(completion.courseObject, variant, "standard", "download");

  // Course doesn't have default certificate or certificate has a cost
  if (!image || !certVariant || certVariant.price > 0) {
    return null;
  }

  const formRef = useRef<HTMLFormElement>(null);
  return (
    <>
      <div className="CourseCertificateDownload">
        {completion.groupCompleted ? (
          <form
            ref={formRef}
            action={API_URL + "/scormview/api/post_download_certificate"}
            method="POST"
            target="_blank">
            <input
              type="hidden"
              name="accessKey"
              value={getAttribute(completion.registrationInfo.orderInfo, "accessKey")}
            />
            <input
              type="hidden"
              name="signature"
              value={getAttribute(completion.registrationInfo.orderInfo, "certsignature")}
            />
            <input type="hidden" name="contentId" value={completion.course} />
            <input
              type="hidden"
              name="fullName"
              value={
                getAttribute(completion.registrationInfo.orderInfo, "firstname") +
                " " +
                getAttribute(completion.registrationInfo.orderInfo, "lastname")
              }
            />
            <input
              type="hidden"
              name="email"
              value={getAttribute(completion.registrationInfo.orderInfo, "email")}
            />
            <input
              type="hidden"
              name="timestamp"
              value={getAttribute(completion.registrationInfo.orderInfo, "timestamp")}
            />
            <input type="hidden" name="cid" value={completion.id} />
            <Button theme="secondary" onClick={() => formRef.current.submit()}>
              Get Certificate
            </Button>
          </form>
        ) : (
          <Button disabled={true}>Get Certificate</Button>
        )}
      </div>
      {/* language=CSS */}
      <style jsx>
        {`
          .CourseCertificateDownload {
          }
        `}
      </style>
    </>
  );
};

export default CourseCertificateDownload;
